import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function getTooltip(message) {
  return <Tooltip id="tooltip">{message}</Tooltip>;
}

function DataPopover({ children, tooltipMessage }) {
  if (!tooltipMessage) {
    return children;
  }
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="bottom"
      overlay={getTooltip(tooltipMessage)}
    >
      <div className="data-popover-wrapper">{children}</div>
    </OverlayTrigger>
  );
}

export default DataPopover;



// WEBPACK FOOTER //
// ./src/components/DataPopover/index.js